import { DOMParser as NodeDOMParser } from 'linkedom';

const BLOCK_END = /<\/(?:p|div|li|h[1-6]|blockquote|tr)>|<br\s*\/?>/gi;

export const htmlToText = (value: string): string => {
  const Parser = typeof window !== 'undefined' ? window.DOMParser : NodeDOMParser;
  // linkedom only populates `body` when the markup is a complete document
  const html = value.replace(BLOCK_END, '$& ');
  const doc = new Parser().parseFromString(`<html><body>${html}</body></html>`, 'text/html');

  for (const el of doc.querySelectorAll('script, style')) {
    el.remove();
  }

  return (doc.body?.textContent ?? '').replace(/\s+/g, ' ').trim();
};
